import { Capacitor } from '@capacitor/core';
import { type FileAsBase64 } from './ProjectSubmission.types';

/**
 * Check if we should use base64 encoding for file uploads.
 * On Capacitor native platforms with CapacitorHttp enabled, FormData file uploads are corrupted.
 * We work around this by sending files as base64-encoded JSON instead.
 *
 * @returns true if we should encode files as base64
 */
export function shouldUseBase64Upload(): boolean {
    return Capacitor.isNativePlatform();
}

/**
 * Convert a File to base64 encoding for transmission as JSON.
 * This bypasses the CapacitorHttp FormData corruption issue.
 *
 * @param file - The File object to convert
 * @returns Promise resolving to base64-encoded file data
 */
export async function convertFileToBase64(file: File): Promise<FileAsBase64> {
    // Read the file as an ArrayBuffer
    const arrayBuffer = await file.arrayBuffer();

    // Convert ArrayBuffer to base64
    const uint8Array = new Uint8Array(arrayBuffer);
    let binaryString = '';
    for (let i = 0; i < uint8Array.length; i++) {
        binaryString += String.fromCharCode(uint8Array[i]);
    }
    const base64Data = btoa(binaryString);

    return {
        filename: file.name,
        content_type: file.type,
        base64_data: base64Data,
    };
}
